
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('assetTypeDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <label v-if="this.$parent.assetTypeNotEmpty" class="form-label">{{ $t('assetTypeNotEmpty') }}</label>
                    <template  v-else-if="this.$parent.foundAssetTypes.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteAssetType') }}</label>
                        <div v-for="(assetType, i) in this.$parent.foundAssetTypes" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/forecast/' + assetType.forecastId ">
                                {{ assetType.name }}
                            </RouterLink>
                        </div>
                    </template>
                    <p v-else>{{ $t('wannaDeleteThisAssetType') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteAssetType" :disabled="this.$parent.foundAssetTypes.length > 0 || this.$parent.assetTypeNotEmpty ">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import AssetTypeApi from "../../api/server/assetType";

export default {
    name: "benefitDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteAssetType() {
            await AssetTypeApi.assetTypeDelete(this.$parent.$route.params.id, this.$parent.$route.params.assetTypeId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        },
    }
};
</script>